import React, { FC } from "react";
import { Column, Columns, Stack } from "@axin-org/comet";

import DashboardHeader from "component/menu/DashboardHeader";
import Indicateur from "component/indicateur/Indicateur";
import HomeAgenda from "component/menu/HomeAgenda";

import ButtonLink from "component/menu/ButtonLink";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { tw } from "twind";

const urls = [
  { label: "crm_accueil_link_create_contact", url: "/create/clientContact" },
  { label: "crm_accueil_link_create_devis", url: "/create/devisClient" },
];

const Accueil: FC<{}> = () => {
  return (
    <Stack gap={2} className={tw("h-full")}>
      <DashboardHeader urls={urls} titleKey="crm_titre_accueil" />

      <Stack gap={2} className={tw("flex-1 overflow-y-auto min-h-0")}>
        <Columns gap={2}>
          <Column width="1/12">
            <ButtonLink
              to="/search/action?term="
              className={tw(
                "bg-blue-700 bg(blue-700 hover:blue-500 focus:blue-500) text-white w-full py-2 rounded",
              )}
            >
              <FontAwesomeIcon icon="magnifying-glass" className={tw("self-center w-full")} />
            </ButtonLink>
          </Column>
          <Column width="11/12">
            <Indicateur
              viewName="vjCrmIndAccueilHaut"
              template="LEFT_TITLE"
              title="crm_accueil_haut"
              filterUser
            />
          </Column>
        </Columns>

        <HomeAgenda />
      </Stack>
    </Stack>
  );
};

export default Accueil;
